import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Header from "./../Header";
import Add_ticket from "./../assets/images/add.png";
import birthday from "../assets/images/birthday.png";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
import moment from "moment";
import pako from "pako";
import Bol from "./bol/Bol";
import HomeAnalytics from "./analytics/HomeAnalytics";
import Tooltip from "rsuite/Tooltip";
import Whisper from "rsuite/Whisper";

class Home extends Component {
	constructor(props) {
		super(props);
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";

		//console.log("localdata", localdata);

		localStorage.setItem("checkedDemoUser", "");
		localStorage.setItem("sortingVisits", "");
		localStorage.setItem("sortingLeads", "");
		localStorage.setItem("sortingCustomers", "");
		var dt = new Date(),
			y = dt.getFullYear(),
			m = dt.getMonth() + 1,
			d = dt.getDate();
		this.state = {
			redirect: false,
			tickets: [],
			owners: [],
			internalowners: [],
			todos: [],
			todoid: "",
			//            leaveHistory: [],
			offToday: [],
			status: "all",
			priority: "all",
			allcustomer: "all",
			type: "all",
			customer: "",
			searchkeyword: "",
			level: "all",
			owner: "all",
			userAuthKey: has_local_data ? localdata.user_key : "",
			apiUrl: this.decryptconfigdata("apiUrl"),
			userId: has_local_data ? localdata.user_id : "",
			user_Name: has_local_data ? localdata.user_name : "",
			user_Email: has_local_data ? localdata.user_email : "",
			user_attachment: has_local_data ? localdata.attachment : "",
			user_postion: has_local_data ? localdata.postion : "",
			emp_start_name: has_local_data ? localdata.emp_first_name : "",
			activePage: 1,
			item_count: "",
			message: "",
			savedFilter: "all",
			saved_filters: [],
			checkBox: true,
			setdefault: "",
			loading: 1,
			isLoadMore: 1,
			popoverOpen: false,
			totalMuvisixCustomer: 0,
			totalMuvisixLead: 0,
			birthdayToday: [],
			birthdayOver: [],
			birthdayUpcoming: [],
			activeUsers: [],
			user_arr: [],
			ticket: "",
			er: "",
			todo: "",
			page_url: "",
			start_year_month: `${y}-01`,
			end_year_month: `${y}-${m}`,
			productWiseCustomer: [],
			productWiseLead: [],
			productWiseRevenue: [],
			holidayList: [],
		};
		this.toggle = this.toggle.bind(this);
		//this.fetchMyBol = this.fetchMyBol.bind(this);
		//this.allUserList = this.allUserList.bind(this);

		this.fetchMyWidget = this.fetchMyWidget.bind(this);
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	getDashboard() {
		fetch(
			this.state.apiUrl +
			"/adminRest/getDashboard/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "GET",
				dataType: "json",
				//            headers: {
				//                'Content-Encoding': 'gzip',
				//                'Content-Type': 'application/json'
				//              }
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				const d = new Date();
				let current_month = d.toLocaleString("default", { month: "long" });
				// console.log("current_month", current_month);
				this.setState(
					{

						totalCustomer: this.state.totalCustomer,
						totalLeads: this.state.totalLeads,
						// totalRevenue: this.state.totalRevenue,
						rewardsPoints: findresponse.rewards_points,
						offToday: findresponse.off_today,
						holidayList: findresponse.holiday,
						current_month: current_month,
						loading: 0,
						position: findresponse.position,
						userLogin: localStorage.getItem("userLogin"),
						birthdayToday: findresponse.bday_today,
						birthdayOver: findresponse.bday_over,
						birthdayUpcoming: findresponse.bday_upcoming,
						user_arr: findresponse.user_arr, // all user array
					},
					function () {
						this.getActiveUsers();
					}
				);
			});
	}
	getActiveUsers() {
		let filtered = Object.values(this.state.user_arr).filter(function (item) {
			return item.is_active == 1;
		});
		filtered.sort(function (a, b) {
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		});
		//active user array
		this.setState({ activeUsers: filtered });
	}
	toggle() {
		this.setState({
			popoverOpen: !this.state.popoverOpen,
		});
	}
	/*getEsop() {
		return (<div class="content-card">
			<div class="leftSVG">
				<svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1.90871 10.4997C1.90871 5.76275 5.76275 1.90871 10.4997 1.90871C15.2367 1.90871 19.0908 5.76275 19.0908 10.4997C19.0908 11.0785 19.0324 11.6581 18.9184 12.2225L20.7892 12.602C20.9291 11.9131 21 11.2062 21 10.5C21 4.71031 16.2897 0 10.5 0C4.71031 0 0 4.71031 0 10.5C0 14.6687 2.46736 18.4445 6.28582 20.1197L7.05292 18.3718C3.92779 17.0005 1.90871 13.9107 1.90871 10.4997Z" fill="#52B7ED"></path>
					<path d="M16.4789 16.2262H17.892L14.4151 19.7033L11.5984 16.8863L6.78369 21.701L8.13349 23.0508L11.5984 19.5859L14.4151 22.4029L19.0909 17.7271V18.8382H20.9999V14.3172H16.4789V16.2262Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="0.5"></path>
					<path d="M14.5427 5.71413V4.79352H7.17773V5.71413H9.70943C10.2175 5.71563 10.7072 5.90419 11.085 6.24382C11.4629 6.58345 11.7024 7.05035 11.7578 7.55537H7.17773V8.47598H11.7578C11.7024 8.981 11.4629 9.4479 11.085 9.78753C10.7072 10.1272 10.2175 10.3157 9.70943 10.3172H7.17773V11.3966L11.6045 15.3806L12.2204 14.6966L8.3773 11.2378H9.70943C10.4625 11.2367 11.1876 10.9519 11.74 10.44C12.2924 9.9281 12.6316 9.22683 12.6899 8.47598H14.5427V7.55537H12.6899C12.6371 6.86419 12.3449 6.21306 11.8637 5.71413H14.5427Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="0.8"></path>
				</svg>
			</div>
			<div class="rightContent">
				<div class="top-text">ESOP</div>
				<div class="middle-text">₹ {this.state.esop != 0 ? this.state.esop : "--"}</div>
			</div>
		</div>
		)
	}*/

	getBirthdayOver() {
		let data = this.state.birthdayOver;
		let isDataEmpty = Object.entries(data).length === 0;
		let birthdayOver = isDataEmpty
			? ""
			: this.state.birthdayOver.map((birthday_over, index) => (
				<div class="single-person">
					<a href={`/viewEmployee/${birthday_over.id}`} class="img-box">
						{birthday_over.attachment ? (
							<img src={birthday_over.attachment} />
						) : (
							<span class="profile_first_name">{birthday_over.name.charAt(0).toUpperCase()}</span>
						)}
					</a>
					<div class="ocontent">
						<a href={`/viewEmployee/${birthday_over.id}`} class="name">
							{birthday_over.name}
						</a>
						<div class="date">
							<span>
								{/* icon and colour change */}
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
									<g clip-path="url(#clip0_331_3364)">
										<path d="M13.2344 6.12516C13.2344 5.60302 13.027 5.10226 12.6577 4.73305C12.2885 4.36384 11.7878 4.15641 11.2656 4.15641H8.76641C8.87202 3.96156 8.94586 3.7511 8.98516 3.53298C9.11094 2.8111 8.87578 2.01813 8.29609 1.17595C8.04649 0.81579 7.76261 0.480634 7.44844 0.175164C7.32685 0.0613635 7.16654 -0.00195312 7 -0.00195312C6.83346 -0.00195312 6.67315 0.0613635 6.55156 0.175164C6.23739 0.480634 5.95351 0.81579 5.70391 1.17595C5.12422 2.01813 4.88906 2.8111 5.01484 3.53298C5.05414 3.7511 5.12798 3.96156 5.23359 4.15641H2.73438C2.21223 4.15641 1.71147 4.36384 1.34226 4.73305C0.973046 5.10226 0.765625 5.60302 0.765625 6.12516V6.85251C0.766707 7.19238 0.834897 7.52869 0.966284 7.84214C1.09767 8.15559 1.28967 8.44001 1.53125 8.67907V11.3752C1.53269 11.6648 1.64838 11.9422 1.85319 12.147C2.058 12.3518 2.33536 12.4675 2.625 12.4689H11.375C11.6646 12.4675 11.942 12.3518 12.1468 12.147C12.3516 11.9422 12.4673 11.6648 12.4688 11.3752V8.67907C12.7103 8.44001 12.9023 8.15559 13.0337 7.84214C13.1651 7.52869 13.2333 7.19238 13.2344 6.85251V6.12516ZM7 1.62985C7.37734 2.10016 7.78203 2.77282 7.69453 3.30876C7.63984 3.60407 7.41016 3.86657 7 4.08532C6.58984 3.86657 6.36016 3.60407 6.31094 3.30876C6.2125 2.77829 6.62266 2.10563 7 1.62985ZM2.07812 6.12516C2.07812 5.95112 2.14727 5.7842 2.27034 5.66113C2.39341 5.53805 2.56033 5.46891 2.73438 5.46891H11.2656C11.4397 5.46891 11.6066 5.53805 11.7297 5.66113C11.8527 5.7842 11.9219 5.95112 11.9219 6.12516V6.85251C11.9214 7.01952 11.8878 7.18479 11.823 7.33873C11.7582 7.49268 11.6636 7.63226 11.5445 7.74938C11.4336 7.8608 11.3014 7.94873 11.1558 8.00792C11.0101 8.06712 10.8541 8.09636 10.6969 8.09391C10.382 8.08679 10.0824 7.95707 9.8618 7.73236C9.64117 7.50765 9.51697 7.2057 9.51562 6.89079C9.51651 6.86877 9.51467 6.84673 9.51016 6.82516C9.48962 6.66709 9.41225 6.52189 9.29249 6.41668C9.17274 6.31148 9.01878 6.25346 8.85938 6.25346C8.69997 6.25346 8.54601 6.31148 8.42626 6.41668C8.3065 6.52189 8.22913 6.66709 8.20859 6.82516C8.20408 6.84673 8.20224 6.86877 8.20312 6.89079C8.20312 7.20988 8.07637 7.5159 7.85074 7.74153C7.62511 7.96716 7.31909 8.09391 7 8.09391C6.68091 8.09391 6.37489 7.96716 6.14926 7.74153C5.92363 7.5159 5.79688 7.20988 5.79688 6.89079C5.79776 6.86877 5.79592 6.84673 5.79141 6.82516C5.77087 6.66709 5.6935 6.52189 5.57374 6.41668C5.45399 6.31148 5.30003 6.25346 5.14062 6.25346C4.98122 6.25346 4.82726 6.31148 4.70751 6.41668C4.58775 6.52189 4.51038 6.66709 4.48984 6.82516C4.48533 6.84673 4.48349 6.86877 4.48438 6.89079C4.48303 7.2057 4.35883 7.50765 4.1382 7.73236C3.91758 7.95707 3.61796 8.08679 3.30313 8.09391C3.14594 8.09636 2.98987 8.06712 2.84423 8.00792C2.69859 7.94873 2.56638 7.8608 2.45547 7.74938C2.33641 7.63226 2.24175 7.49268 2.17698 7.33873C2.11221 7.18479 2.07861 7.01952 2.07812 6.85251V6.12516ZM2.84375 11.1564V9.36813C3.00461 9.39466 3.16744 9.40747 3.33047 9.40641C3.67145 9.39771 4.00713 9.32006 4.31729 9.17814C4.62745 9.03622 4.90566 8.83297 5.13516 8.58063C5.37144 8.84036 5.65937 9.04786 5.9805 9.18985C6.30163 9.33184 6.64888 9.40518 7 9.40518C7.35112 9.40518 7.69837 9.33184 8.0195 9.18985C8.34063 9.04786 8.62856 8.84036 8.86484 8.58063C9.09434 8.83297 9.37255 9.03622 9.68271 9.17814C9.99287 9.32006 10.3286 9.39771 10.6695 9.40641H10.7188C10.8653 9.40476 11.0116 9.39196 11.1562 9.36813V11.1564H2.84375Z" fill="#0063E1" />
									</g>
									<defs>
										<clipPath id="clip0_331_3364">
											<rect width="14" height="14" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</span>
							{birthday_over.dob}
						</div>
					</div>
				</div>
			));
		return (
			<div>
				{birthdayOver ? (
					<div>
						<div class="recent-title">RECENT BIRTHDAYS</div>
						<div class="parent-single">{birthdayOver}</div>
					</div>
				) : (
					""
				)}
			</div>
		);
	}

	getBirthdayUpcoming() {
		let dataUpcoming = this.state.birthdayUpcoming;
		let isDataUpcomingEmpty = Object.entries(dataUpcoming).length === 0;
		let birthdayUpcoming = isDataUpcomingEmpty
			? ""
			: this.state.birthdayUpcoming.map((birthday_upcoming, index) => (
				<div class="single-person">
					<a href={`/viewEmployee/${birthday_upcoming.id}`} class="img-box">
						{birthday_upcoming.attachment ? (
							<img src={birthday_upcoming.attachment} />
						) : (
							<span class="profile_first_name">{birthday_upcoming.name.charAt(0).toUpperCase()}</span>
						)}
					</a>
					<div class="ocontent">
						<a href={`/viewEmployee/${birthday_upcoming.id}`} class="name">
							{birthday_upcoming.name}
						</a>
						<div class="date">
							<span>
								{/* icon and colour change */}
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
									<g clip-path="url(#clip0_331_3364)">
										<path d="M13.2344 6.12516C13.2344 5.60302 13.027 5.10226 12.6577 4.73305C12.2885 4.36384 11.7878 4.15641 11.2656 4.15641H8.76641C8.87202 3.96156 8.94586 3.7511 8.98516 3.53298C9.11094 2.8111 8.87578 2.01813 8.29609 1.17595C8.04649 0.81579 7.76261 0.480634 7.44844 0.175164C7.32685 0.0613635 7.16654 -0.00195312 7 -0.00195312C6.83346 -0.00195312 6.67315 0.0613635 6.55156 0.175164C6.23739 0.480634 5.95351 0.81579 5.70391 1.17595C5.12422 2.01813 4.88906 2.8111 5.01484 3.53298C5.05414 3.7511 5.12798 3.96156 5.23359 4.15641H2.73438C2.21223 4.15641 1.71147 4.36384 1.34226 4.73305C0.973046 5.10226 0.765625 5.60302 0.765625 6.12516V6.85251C0.766707 7.19238 0.834897 7.52869 0.966284 7.84214C1.09767 8.15559 1.28967 8.44001 1.53125 8.67907V11.3752C1.53269 11.6648 1.64838 11.9422 1.85319 12.147C2.058 12.3518 2.33536 12.4675 2.625 12.4689H11.375C11.6646 12.4675 11.942 12.3518 12.1468 12.147C12.3516 11.9422 12.4673 11.6648 12.4688 11.3752V8.67907C12.7103 8.44001 12.9023 8.15559 13.0337 7.84214C13.1651 7.52869 13.2333 7.19238 13.2344 6.85251V6.12516ZM7 1.62985C7.37734 2.10016 7.78203 2.77282 7.69453 3.30876C7.63984 3.60407 7.41016 3.86657 7 4.08532C6.58984 3.86657 6.36016 3.60407 6.31094 3.30876C6.2125 2.77829 6.62266 2.10563 7 1.62985ZM2.07812 6.12516C2.07812 5.95112 2.14727 5.7842 2.27034 5.66113C2.39341 5.53805 2.56033 5.46891 2.73438 5.46891H11.2656C11.4397 5.46891 11.6066 5.53805 11.7297 5.66113C11.8527 5.7842 11.9219 5.95112 11.9219 6.12516V6.85251C11.9214 7.01952 11.8878 7.18479 11.823 7.33873C11.7582 7.49268 11.6636 7.63226 11.5445 7.74938C11.4336 7.8608 11.3014 7.94873 11.1558 8.00792C11.0101 8.06712 10.8541 8.09636 10.6969 8.09391C10.382 8.08679 10.0824 7.95707 9.8618 7.73236C9.64117 7.50765 9.51697 7.2057 9.51562 6.89079C9.51651 6.86877 9.51467 6.84673 9.51016 6.82516C9.48962 6.66709 9.41225 6.52189 9.29249 6.41668C9.17274 6.31148 9.01878 6.25346 8.85938 6.25346C8.69997 6.25346 8.54601 6.31148 8.42626 6.41668C8.3065 6.52189 8.22913 6.66709 8.20859 6.82516C8.20408 6.84673 8.20224 6.86877 8.20312 6.89079C8.20312 7.20988 8.07637 7.5159 7.85074 7.74153C7.62511 7.96716 7.31909 8.09391 7 8.09391C6.68091 8.09391 6.37489 7.96716 6.14926 7.74153C5.92363 7.5159 5.79688 7.20988 5.79688 6.89079C5.79776 6.86877 5.79592 6.84673 5.79141 6.82516C5.77087 6.66709 5.6935 6.52189 5.57374 6.41668C5.45399 6.31148 5.30003 6.25346 5.14062 6.25346C4.98122 6.25346 4.82726 6.31148 4.70751 6.41668C4.58775 6.52189 4.51038 6.66709 4.48984 6.82516C4.48533 6.84673 4.48349 6.86877 4.48438 6.89079C4.48303 7.2057 4.35883 7.50765 4.1382 7.73236C3.91758 7.95707 3.61796 8.08679 3.30313 8.09391C3.14594 8.09636 2.98987 8.06712 2.84423 8.00792C2.69859 7.94873 2.56638 7.8608 2.45547 7.74938C2.33641 7.63226 2.24175 7.49268 2.17698 7.33873C2.11221 7.18479 2.07861 7.01952 2.07812 6.85251V6.12516ZM2.84375 11.1564V9.36813C3.00461 9.39466 3.16744 9.40747 3.33047 9.40641C3.67145 9.39771 4.00713 9.32006 4.31729 9.17814C4.62745 9.03622 4.90566 8.83297 5.13516 8.58063C5.37144 8.84036 5.65937 9.04786 5.9805 9.18985C6.30163 9.33184 6.64888 9.40518 7 9.40518C7.35112 9.40518 7.69837 9.33184 8.0195 9.18985C8.34063 9.04786 8.62856 8.84036 8.86484 8.58063C9.09434 8.83297 9.37255 9.03622 9.68271 9.17814C9.99287 9.32006 10.3286 9.39771 10.6695 9.40641H10.7188C10.8653 9.40476 11.0116 9.39196 11.1562 9.36813V11.1564H2.84375Z" fill="#0063E1" />
									</g>
									<defs>
										<clipPath id="clip0_331_3364">
											<rect width="14" height="14" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</span>
							{birthday_upcoming.dob}
						</div>
					</div>
				</div>
			));
		return (
			<div>
				{birthdayUpcoming ? (
					<div>
						<div class="recent-title">UPCOMING BIRTHDAYS</div>
						<div class="parent-single">{birthdayUpcoming}</div>
					</div>
				) : (
					""
				)}
			</div>
		);
	}

	getBirthday() {
		$(document).ready(function () {
			$(window).on("load", function () {
				if ($.mCustomScrollbar) {
					$.mCustomScrollbar.defaults.theme = "light-2"; //set "light-2" as the default theme
				}

				//$(".demo-y").mCustomScrollbar();

				$(".scrollTo a").click(function (e) {
					e.preventDefault();
					var $this = $(this),
						rel = $this.attr("rel"),
						el = rel === "content-y" ? ".demo-y" : rel === "content-x" ? ".demo-x" : ".demo-yx",
						data = $this.data("scroll-to"),
						href = $this.attr("href").split(/#(.+)/)[1],
						to = data
							? $(el).find(".mCSB_container").find(data)
							: el === ".demo-yx"
								? eval("(" + href + ")")
								: href,
						output = $("#info > p code"),
						outputTXTdata = el === ".demo-yx" ? data : "'" + data + "'",
						outputTXThref = el === ".demo-yx" ? href : "'" + href + "'",
						outputTXT = data
							? "$('" + el + "').find('.mCSB_container').find(" + outputTXTdata + ")"
							: outputTXThref;
					$(el).mCustomScrollbar("scrollTo", to);
					output.text("$('" + el + "').mCustomScrollbar('scrollTo'," + outputTXT + ");");
				});
			});

			$(".panel-collapse").on("show.bs.collapse", function () {
				$(this).siblings(".panel-heading").addClass("active");
			});

			$(".panel-collapse").on("hide.bs.collapse", function () {
				$(this).siblings(".panel-heading").removeClass("active");
			});
		});
		if (this.state.birthdayToday != "" || this.state.birthdayOver != "" || this.state.birthdayUpcoming != "") {
			return (
				<div class="inner-birthday">
					<div class="parent-single">
						{this.state.birthdayToday &&
							this.state.birthdayToday.map((birthday_today, key) => (
								<div class="single-person">
									<a href={`/viewEmployee/${birthday_today.id}`} class="img-box">
										{birthday_today.attachment ? (
											<img src={birthday_today.attachment} />
										) : (
											<span class="profile_first_name">
												{birthday_today.name.charAt(0).toUpperCase()}
											</span>
										)}
									</a>
									<div class="ocontent">
										<a href={`/viewEmployee/${birthday_today.id}`} class="name">
											{birthday_today.name}
										</a>
										<div class="date">
											<span>
												{/* icon and colour change */}
												<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
													<g clip-path="url(#clip0_331_3364)">
														<path d="M13.2344 6.12516C13.2344 5.60302 13.027 5.10226 12.6577 4.73305C12.2885 4.36384 11.7878 4.15641 11.2656 4.15641H8.76641C8.87202 3.96156 8.94586 3.7511 8.98516 3.53298C9.11094 2.8111 8.87578 2.01813 8.29609 1.17595C8.04649 0.81579 7.76261 0.480634 7.44844 0.175164C7.32685 0.0613635 7.16654 -0.00195312 7 -0.00195312C6.83346 -0.00195312 6.67315 0.0613635 6.55156 0.175164C6.23739 0.480634 5.95351 0.81579 5.70391 1.17595C5.12422 2.01813 4.88906 2.8111 5.01484 3.53298C5.05414 3.7511 5.12798 3.96156 5.23359 4.15641H2.73438C2.21223 4.15641 1.71147 4.36384 1.34226 4.73305C0.973046 5.10226 0.765625 5.60302 0.765625 6.12516V6.85251C0.766707 7.19238 0.834897 7.52869 0.966284 7.84214C1.09767 8.15559 1.28967 8.44001 1.53125 8.67907V11.3752C1.53269 11.6648 1.64838 11.9422 1.85319 12.147C2.058 12.3518 2.33536 12.4675 2.625 12.4689H11.375C11.6646 12.4675 11.942 12.3518 12.1468 12.147C12.3516 11.9422 12.4673 11.6648 12.4688 11.3752V8.67907C12.7103 8.44001 12.9023 8.15559 13.0337 7.84214C13.1651 7.52869 13.2333 7.19238 13.2344 6.85251V6.12516ZM7 1.62985C7.37734 2.10016 7.78203 2.77282 7.69453 3.30876C7.63984 3.60407 7.41016 3.86657 7 4.08532C6.58984 3.86657 6.36016 3.60407 6.31094 3.30876C6.2125 2.77829 6.62266 2.10563 7 1.62985ZM2.07812 6.12516C2.07812 5.95112 2.14727 5.7842 2.27034 5.66113C2.39341 5.53805 2.56033 5.46891 2.73438 5.46891H11.2656C11.4397 5.46891 11.6066 5.53805 11.7297 5.66113C11.8527 5.7842 11.9219 5.95112 11.9219 6.12516V6.85251C11.9214 7.01952 11.8878 7.18479 11.823 7.33873C11.7582 7.49268 11.6636 7.63226 11.5445 7.74938C11.4336 7.8608 11.3014 7.94873 11.1558 8.00792C11.0101 8.06712 10.8541 8.09636 10.6969 8.09391C10.382 8.08679 10.0824 7.95707 9.8618 7.73236C9.64117 7.50765 9.51697 7.2057 9.51562 6.89079C9.51651 6.86877 9.51467 6.84673 9.51016 6.82516C9.48962 6.66709 9.41225 6.52189 9.29249 6.41668C9.17274 6.31148 9.01878 6.25346 8.85938 6.25346C8.69997 6.25346 8.54601 6.31148 8.42626 6.41668C8.3065 6.52189 8.22913 6.66709 8.20859 6.82516C8.20408 6.84673 8.20224 6.86877 8.20312 6.89079C8.20312 7.20988 8.07637 7.5159 7.85074 7.74153C7.62511 7.96716 7.31909 8.09391 7 8.09391C6.68091 8.09391 6.37489 7.96716 6.14926 7.74153C5.92363 7.5159 5.79688 7.20988 5.79688 6.89079C5.79776 6.86877 5.79592 6.84673 5.79141 6.82516C5.77087 6.66709 5.6935 6.52189 5.57374 6.41668C5.45399 6.31148 5.30003 6.25346 5.14062 6.25346C4.98122 6.25346 4.82726 6.31148 4.70751 6.41668C4.58775 6.52189 4.51038 6.66709 4.48984 6.82516C4.48533 6.84673 4.48349 6.86877 4.48438 6.89079C4.48303 7.2057 4.35883 7.50765 4.1382 7.73236C3.91758 7.95707 3.61796 8.08679 3.30313 8.09391C3.14594 8.09636 2.98987 8.06712 2.84423 8.00792C2.69859 7.94873 2.56638 7.8608 2.45547 7.74938C2.33641 7.63226 2.24175 7.49268 2.17698 7.33873C2.11221 7.18479 2.07861 7.01952 2.07812 6.85251V6.12516ZM2.84375 11.1564V9.36813C3.00461 9.39466 3.16744 9.40747 3.33047 9.40641C3.67145 9.39771 4.00713 9.32006 4.31729 9.17814C4.62745 9.03622 4.90566 8.83297 5.13516 8.58063C5.37144 8.84036 5.65937 9.04786 5.9805 9.18985C6.30163 9.33184 6.64888 9.40518 7 9.40518C7.35112 9.40518 7.69837 9.33184 8.0195 9.18985C8.34063 9.04786 8.62856 8.84036 8.86484 8.58063C9.09434 8.83297 9.37255 9.03622 9.68271 9.17814C9.99287 9.32006 10.3286 9.39771 10.6695 9.40641H10.7188C10.8653 9.40476 11.0116 9.39196 11.1562 9.36813V11.1564H2.84375Z" fill="#0063E1" />
													</g>
													<defs>
														<clipPath id="clip0_331_3364">
															<rect width="14" height="14" fill="white" />
														</clipPath>
													</defs>
												</svg>
											</span>
											Today
										</div>
									</div>
								</div>
							))}
					</div>
					{this.state.birthdayOver ? this.getBirthdayOver() : ""}
					{this.state.birthdayUpcoming ? this.getBirthdayUpcoming() : ""}
				</div>
			);
		} else {
			return (
				<div class="parent-single">
					<div class="no_birthday">
						{/* <div class="no_text">
							Keep Calm there's
							<br />
							No birthdays for this week
						</div>
						<img src={birthday} class="img-responsive" /> */}
					</div>
				</div>
			);
		}
	}

	getHolidayList() {
		const { holidayList } = this.state;

		return (
			<div className="inner-holiday">
				{holidayList.map((holiday, index) => (
					<div className="single-holiday" key={index}>
						<div className="small-box"></div>
						<div className="hcontent">
							<div className="name">{holiday.name}</div>
							<div className="date">{holiday.formatted_date}</div>
						</div>
					</div>
				))}
			</div>
		);
	}
	componentDidMount() {
		document.title = "Intranet | Home";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
		try {
			/*
			fetch(this.state.apiUrl + "/RevenueRest/activeProductStatistics/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
			})
				.then((Response) => Response.json())
				.then((findresponse) => {
					this.setState(
						{
							totalCustomer: findresponse.total_customers,
							totalLeads: findresponse.total_leads,
						},
						() => {
							//this.getDashboard()
						}
					);
				});

			// Added by Bibhuti - 30th Nov 2023
			const filter_params = {
				start_date: this.state.end_year_month,
				end_date: this.state.end_year_month,
			};
			fetch(process.env.REACT_APP_CRM + "/analytics/get-data", {
				method: "POST",
				body: JSON.stringify(filter_params),
			})
				.then((Response) => Response.json())
				.then((findresponse) => {
					this.setState(
						{
							totalRevenue: findresponse.total_revenue,
						},
						() => {
							//
						}
					);
				});
				*/
			/**
			 * Added By SUSHANTA  - 29th Septmber 20204
			 */
			//fetch customer. leads and product wise customer data in CRM
			fetch(process.env.REACT_APP_CRM + "/crm/statistics")
				.then((Response) => Response.json())
				.then((findresponse) => {
					// console.log(findresponse);
					if (findresponse && findresponse.code == 200) {
						this.setState({
							totalCustomer: findresponse && findresponse.data.TOTAL_CUSTOMER,
							totalLeads: findresponse && findresponse.data.TOTAL_LEAD,
							productWiseCustomer: findresponse && findresponse.customers,
							productWiseLead: findresponse && findresponse.leads,
							totalRevenue: findresponse && Math.floor(findresponse.tottal_revenue.revenue),
							productWiseRevenue: findresponse && findresponse.revenues,
						});
					}
				})
				.catch((error) => {
					console.error("There was a problem with the fetch operation:", error);
				});
		} catch (error) {
			console.log(error);
		}
		this.getDashboard();
		this.fetchMyWidget();
		//this.fetchMyBol(this.state.userId,1,0);
	}
	fetchMyWidget() {
		fetch(
			this.state.apiUrl +
			"/adminRest/getMyWidget/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					ticket: findresponse.data.support_ticket,
					er: findresponse.data.er,
					todo: findresponse.data.todo,
					page_url: findresponse.data.page_url,
				});
			});
	}

	openWidget(url) {
		var page_url = this.state.page_url;
		window.open(page_url + url + "/list/filter/me", "_blank");
	}

	openWidgetKanban(url) {
		var page_url = this.state.page_url;
		window.open(page_url + url + "/kanban/filter/me", "_blank");
	}

	//Added by SUSHANTA
	renderSpeaker = (productWiseCustomer) => {
		return (
			<Tooltip style={{ background: "#343434", marginTop: "100px" }}>
				<ul className="list-styled rightContent">
					{productWiseCustomer.map((prod, index) => (
						<li
							className="list-view"
							style={{
								width: "200px",
								borderBottom: index !== productWiseCustomer.length - 1 ? "1px solid #a1a3a99c" : "none",
							}}
						>
							<div className="top-text" style={{ color: "#a1a3a9" }}>
								{prod.name}
							</div>
							<span style={{ color: "#a1a3a9" }}>{prod.total_customers}</span>
						</li>
					))}
				</ul>
			</Tooltip>
		);
	};
	//Added by SUSHANTA
	renderSpeakerRevenue = (productWiseCustomer) => {
		return (
			<Tooltip style={{ background: "#343434", marginTop: "50px" }}>
				<ul className="list-styled rightContent">
					{productWiseCustomer.map((prod, index) => (
						<li
							className="list-view"
							style={{
								width: "200px",
								borderBottom: index !== productWiseCustomer.length - 1 ? "1px solid #a1a3a99c" : "none",
							}}
						>
							<div className="top-text" style={{ color: "#a1a3a9" }}>
								{prod.name}
							</div>
							<span style={{ color: "#a1a3a9" }}>${Math.floor(prod.total_customers)}</span>
						</li>
					))}
				</ul>
			</Tooltip>
		);
	};

	getHomeDetails() {
		if (this.state.loading) {
			return (
				<div>
					<div class="loader-new"></div>
				</div>
			);
		} else {
			return (
				<div class="intranet_body dashboard">
					<div class="top-numberStatics">
						<div class="flexrow">
							<div class="underFlex">
								<Link to={`/accounts/list?type=customer`} name={"max"}>
									<div class="content-card">
										<div class="leftSVG">
											{/* icon and colour change */}
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
											</svg>
										</div>
										<div class="rightContent">
											<div class="top-text">
												Customers
												<span>
													<svg
														width="14"
														height="14"
														viewBox="0 0 14 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M5.25 10.5L8.75 7L5.25 3.5"
															stroke="#BDBDBD"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</span>
											</div>
											<div class="middle-text">
												{this.state.totalCustomer}
												<Whisper
													followCursor={true}
													speaker={this.renderSpeaker(this.state.productWiseCustomer)}
												>
													<i
														className="fa fa-info-circle"
														aria-hidden="true"
														style={{
															fontSize: "12px",
															paddingLeft: "5px",
															color: "#666666",
														}}
													></i>
												</Whisper>
											</div>
										</div>
									</div>
								</Link>
							</div>
							<div class="underFlex">
								<Link to={`/accounts/list?type=lead`} name={"max"}>
									<div class="content-card">
										<div class="leftSVG">
											{/* icon and colour change */}
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
											</svg>
										</div>
										<div class="rightContent">
											<div class="top-text">
												Leads
												<span>
													<svg
														width="14"
														height="14"
														viewBox="0 0 14 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M5.25 10.5L8.75 7L5.25 3.5"
															stroke="#BDBDBD"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</span>
											</div>
											<div class="middle-text">
												{this.state.totalLeads}
												<Whisper
													trigger="hover"
													speaker={this.renderSpeaker(this.state.productWiseLead)}
												>
													<i
														className="fa fa-info-circle"
														aria-hidden="true"
														style={{
															fontSize: "12px",
															paddingLeft: "5px",
															color: "#666666",
														}}
													></i>
												</Whisper>
											</div>
										</div>
									</div>
								</Link>
							</div>
							<div class="underFlex">
								<Link to={`/revenue/`} name={"max"}>
									<div class="content-card">
										<div class="leftSVG">
											{/* icon and colour change */}
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M23.0602 20.1111H22.2454V3.81481C22.2454 3.59871 22.1595 3.39146 22.0067 3.23865C21.8539 3.08585 21.6467 3 21.4306 3H15.7269C15.5108 3 15.3035 3.08585 15.1507 3.23865C14.9979 3.39146 14.912 3.59871 14.912 3.81481V7.88889H10.0231C9.80705 7.88889 9.5998 7.97474 9.44699 8.12754C9.29418 8.28035 9.20833 8.4876 9.20833 8.7037V12.7778H4.31944C4.10334 12.7778 3.89609 12.8636 3.74328 13.0164C3.59048 13.1692 3.50463 13.3765 3.50463 13.5926V20.1111H2.68981C2.47371 20.1111 2.26646 20.197 2.11365 20.3498C1.96085 20.5026 1.875 20.7098 1.875 20.9259C1.875 21.142 1.96085 21.3493 2.11365 21.5021C2.26646 21.6549 2.47371 21.7407 2.68981 21.7407H23.0602C23.2763 21.7407 23.4835 21.6549 23.6363 21.5021C23.7892 21.3493 23.875 21.142 23.875 20.9259C23.875 20.7098 23.7892 20.5026 23.6363 20.3498C23.4835 20.197 23.2763 20.1111 23.0602 20.1111ZM10.838 9.51852H14.912V20.1111H10.838V9.51852ZM5.13426 14.4074H9.20833V20.1111H5.13426V14.4074Z" fill="#006EFA" />
											</svg>
										</div>
										<div class="rightContent">
											<div class="top-text">
												Revenue
												<span>
													<svg
														width="14"
														height="14"
														viewBox="0 0 14 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M5.25 10.5L8.75 7L5.25 3.5"
															stroke="#BDBDBD"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</span>
											</div>
											<div class="middle-text">
												${this.state.totalRevenue ? this.state.totalRevenue : "--"}
												<Whisper
													trigger="hover"
													speaker={this.renderSpeakerRevenue(this.state.productWiseRevenue)}
												>
													<i
														className="fa fa-info-circle"
														aria-hidden="true"
														style={{
															fontSize: "12px",
															paddingLeft: "5px",
															color: "#666666",
														}}
													></i>
												</Whisper>
											</div>
											<div class="bottom-text">{this.state.current_month}</div>
										</div>
									</div>
								</Link>
							</div>
							<div class="underFlex">
								<div>
									<div class="content large">
										<ul class="list-styled rightContent">
											<a onClick={() => this.openWidget("support-ticket")}>
												<li class="list-view">
													<div class="top-text">Tickets</div>
													<span>
														{this.state.ticket ? this.state.ticket : 0}
														<svg
															width="14"
															height="14"
															viewBox="0 0 14 14"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M5.25 10.5L8.75 7L5.25 3.5"
																stroke="#BDBDBD"
																stroke-width="1.33"
																stroke-linecap="round"
																stroke-linejoin="round"
															></path>
														</svg>
													</span>
												</li>
											</a>
											<a onClick={() => this.openWidget("er")}>
												<li class="list-view">
													<div class="top-text">ERs</div>
													<span>
														{this.state.er ? this.state.er : 0}
														<svg
															width="14"
															height="14"
															viewBox="0 0 14 14"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M5.25 10.5L8.75 7L5.25 3.5"
																stroke="#BDBDBD"
																stroke-width="1.33"
																stroke-linecap="round"
																stroke-linejoin="round"
															></path>
														</svg>
													</span>
												</li>
											</a>
											<a onClick={() => this.openWidgetKanban("todo")}>
												<li>
													<div class="top-text">To DOs</div>
													<span>
														{this.state.todo ? this.state.todo : 0}
														<svg
															width="14"
															height="14"
															viewBox="0 0 14 14"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M5.25 10.5L8.75 7L5.25 3.5"
																stroke="#BDBDBD"
																stroke-width="1.33"
																stroke-linecap="round"
																stroke-linejoin="round"
															></path>
														</svg>
													</span>
												</li>
											</a>
										</ul>
									</div>
								</div>
							</div>
							<div class="underFlex">
								<div>
									<div class="content large">
										<div>
											<ul class="header-policy-list">
												<li>
													<span class="header-policy">Policies</span>
													<span class="header-policy-svg">
														<svg
															width="14"
															height="14"
															viewBox="0 0 14 14"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M5.25 10.5L8.75 7L5.25 3.5"
																stroke="#BDBDBD"
																stroke-width="1.33"
																stroke-linecap="round"
																stroke-linejoin="round"
															></path>
														</svg>
													</span>
												</li>
											</ul>
											<ul class="list-styled rightContent">
												<a
													href="https://docs.google.com/document/d/1uVl9JI8Abw_fXm6e38WAR1hYg8T-eha6op_mrPCHRl0/edit"
													target="_blank"
												>
													<li class="list-view">
														<div class="top-text">Work Culture</div>
													</li>
												</a>
												<a
													href="https://docs.google.com/document/d/1YOfpA52gGWMe4kfaYGUTIR-50oicYpO1ZOvKczWmHLQ/edit"
													target="_blank"
												>
													<li>
														<div class="top-text">HR Policy</div>
													</li>
												</a>
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div class="underFlex">
								<Link to={`/leaveReward`} name={"max"}>
									<div class="content-card">
										<div class="leftSVG">
											{/* icon and colour change */}
											<svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27" fill="none">
												<path d="M11.6812 6.625L12.8399 9.09342L15.4311 9.49168L13.5561 11.412L13.9986 14.1249L11.6812 12.8434L9.36369 14.1249L9.80619 11.412L7.93121 9.49168L10.5224 9.09342L11.6812 6.625Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M14.4426 19.6926L17.5527 25.0261L19.1029 21.7838L23.4002 23.1519L19.6499 15.9998" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M4.00671 16.2188L1.22069 23.1006L4.95524 22.0565L6.94873 25.2411L9.4367 19.5546" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												<path d="M11.6811 19.7497C16.8587 19.7497 21.0559 15.5525 21.0559 10.3749C21.0559 5.19727 16.8587 1 11.6811 1C6.50348 1 2.30621 5.19727 2.30621 10.3749C2.30621 15.5525 6.50348 19.7497 11.6811 19.7497Z" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
											</svg>
										</div>
										<div class="rightContent">
											<div class="top-text">
												{this.state.rewardsPoints <= 1 ? "Reward" : "Rewards"}
												<span>
													<svg
														width="14"
														height="14"
														viewBox="0 0 14 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M5.25 10.5L8.75 7L5.25 3.5"
															stroke="#BDBDBD"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</span>
											</div>
											<div class="middle-text">
												{this.state.rewardsPoints ? this.state.rewardsPoints : "--"}
											</div>
										</div>
									</div>
								</Link>
							</div>
							{/*<div class="underFlex">
                                {this.getEsop()}
                            </div>*/}
						</div>
					</div>
					<div class="bottomhome-boxpart">
						<div class="row">
							<div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 pr-spacing">
								<HomeAnalytics />
								<div class="homespc-day-box">
									<div class="row">
										<div class="col-md-4 birth-col">
											<div class="birthday-area">
												<div class="today-title">Birthdays</div>
												{this.getBirthday()}
											</div>
										</div>
										<div class="col-md-4 holi-col">
											<div class="birthday-area">
												<div class="today-title">Holidays</div>
												{this.getHolidayList()}
											</div>
										</div>
										<div class="col-md-4 off-col">
											<div class="birthday-area offtoday-area">
												<div class="today-title">Leaves</div>
												<div class="inner-birthday">
													<div class="parent-single">
														{this.state.offToday &&
															this.state.offToday.map((leave_today, key) => (
																<div class="single-person">
																	<a
																		href={`/viewEmployee/${leave_today.emp_id}`}
																		class="img-box"
																	>
																		<img src={leave_today.attachment} />
																	</a>
																	<div class="ocontent">
																		<a
																			href={`/viewEmployee/${leave_today.emp_id}`}
																			class="name"
																		>
																			{leave_today.employee_name}
																		</a>
																		<div class="date recent">
																			{leave_today.leave_type}
																		</div>
																	</div>
																</div>
															))}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<Bol
								userArr={this.state.user_arr}
								mentionuserArr={this.state.activeUsers}
								emp_name={this.state.user_Name}
								position={this.state.user_position}
								attachment={this.state.user_attachment}
								emp_start_name={this.state.emp_start_name}
								userId={this.state.userId}
							/>
						</div>
					</div>

					<div class="dashboard_list leave hidden">
						<div class="row">
							<div class="col-md-6">
								<div class="list_todo bg-white">
									<div class="dash_title">
										<span>Off Today</span>
										<div class="tickets Thome">
											<ul class="tickets_head">
												<li class="intra_col_25">Employee Name</li>
												<li class="intra_col_25">Designation</li>
												<li class="intra_col_25">Leave From</li>
												<li class="intra_col_25">Leave To</li>
											</ul>
											<ul class="Scroll_dash">
												{this.state.offToday &&
													this.state.offToday.map((leave_today, key) => (
														<ul class="tickets_number">
															<li class="intra_col_25">
																<Link
																	to={`/viewEmployee/${leave_today.emp_id}`}
																	name={"max"}
																>
																	{leave_today.employee_name}
																</Link>
															</li>
															<li class="intra_col_25">{leave_today.position}</li>
															<li class="intra_col_25">
																{new Intl.DateTimeFormat("en-US", {
																	year: "numeric",
																	month: "long",
																	day: "2-digit",
																}).format(new Date(leave_today.date))}
															</li>
															<li class="intra_col_25">
																{new Intl.DateTimeFormat("en-US", {
																	year: "numeric",
																	month: "long",
																	day: "2-digit",
																}).format(new Date(leave_today.to_date))}
															</li>
														</ul>
													))}
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="list_todo bg-white">
									<div class="dash_title">
										<span>To do List</span>
										<div class="tickets Thome">
											<ul class="tickets_head">
												<li class="intra_col_30">Title</li>
												<li class="intra_col_16">Status</li>
												<li class="intra_col_16">ETA</li>
												<li class="intra_col_25">Priority</li>
												<li class="intra_col_16">Action</li>
											</ul>
											<ul class="Scroll_dash">
												{this.state.todos.map((todo, key) => (
													<ul class="tickets_number">
														<li class="intra_col_30">{todo.title}</li>
														<li class="intra_col_16">{todo.status}</li>
														<li class="intra_col_16">{todo.ETA}</li>
														<li class="intra_col_25">
															<div class={"btn btn-trans" + " " + todo.priority}>
																{todo.priority}
															</div>
														</li>
														<li class="intra_col_16">
															<Link key={key} to={`/updateTodo/${todo.id}`} name={"max"}>
																<i class="fa fa-pencil-square-o"></i>
															</Link>
														</li>
													</ul>
												))}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			);
		}
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				<Header brecum_name="" brecum_page="" />
				<div class="right_col">{this.getHomeDetails()}</div>
			</div>
		);
	}
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js